"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
const ProjectSelector_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectSelector.vue"));
const ProjectItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Projects/ProjectItem.vue"));
const MetricItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Metrics/MetricItem.vue"));
const CustomerSwitcher_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/CustomerSwitcher.vue"));
let ProjectControl = class ProjectControl extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.collapseLevel = 2; // 0 no collapsed, 1 partially, 2 full collapsed
        this.isHovered = false;
        this.projectActiveInSelect = this.projectSelected;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get entitySelected() {
        if (this.currentFarm)
            return this.currentFarm;
        return this.projectSelected;
    }
    toggleProjectControl() {
        if (this.collapseLevel == 2) {
            this.collapseLevel = 0;
        }
        else {
            if (this.projectSelected.project_type === 'rate') {
                this.collapseLevel = 2;
            }
            else {
                this.collapseLevel = this.collapseLevel + 1;
            }
        }
    }
    get metric() {
        return (this.isDoblePanelDeployed) ?
            (this.dimension === 'bio') ?
                this.vsMetric :
                this.vsPhChMetric
            :
                (this.dimension === 'bio') ?
                    this.currentMetric :
                    this.phchMetric;
        return new project_1.BioMetric({}, {});
    }
    currentProjectIx() {
        if (this.projectSelected) {
            return this.projects.findIndex((p) => p.area_id === this.projectSelected.area_id && p.project_id === this.projectSelected.project_id);
        }
        else {
            return -1;
        }
    }
    loadPreviousProject() {
        let prevProject = new project_1.AreaProjectBuilt({});
        if (!this.isDoblePanelDeployed) {
            if (this.currentProjectIx() > 0) {
                prevProject = this.projects[this.currentProjectIx() - 1];
            }
            else {
                prevProject = this.projectSelected;
            }
        }
        else {
            const curatedProjects = this.projects.filter((p) => p.project_type !== 'rate' && p !== this.disabledProject);
            const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.projectSelected);
            if (curatedProjectsCurrIx === 0) {
                prevProject = curatedProjects[curatedProjects.length - 1];
            }
            else {
                prevProject = curatedProjects[curatedProjectsCurrIx - 1];
            }
        }
        this.updateProjectSelected(prevProject);
    }
    loadNextProject() {
        let nextProject = new project_1.AreaProjectBuilt({});
        if (!this.isDoblePanelDeployed) {
            if (this.currentProjectIx() < this.projects.length) {
                nextProject = this.projects[this.currentProjectIx() + 1];
            }
            else {
                nextProject = this.projectSelected;
            }
        }
        else {
            const curatedProjects = this.projects.filter((p) => p.project_type !== 'rate' && p !== this.disabledProject);
            const curatedProjectsCurrIx = curatedProjects.findIndex((p) => p === this.projectSelected);
            if (curatedProjectsCurrIx < curatedProjects.length) {
                nextProject = curatedProjects[curatedProjectsCurrIx + 1];
            }
            else {
                nextProject = this.projectSelected;
            }
        }
        this.updateProjectSelected(nextProject);
    }
    get isMainLoading() {
        return this.loadingDetailStatus.type == 'delivery' || this.loadingDetailStatus.type == 'list';
    }
    get isSecondaryLoading() {
        return this.loadingDetailStatus.type == 'delivery2';
    }
    get isLoading() {
        if (this.isMainSelector) {
            return this.isMainLoading;
        }
        else {
            return this.isSecondaryLoading;
        }
    }
    get myMessage() {
        var _a, _b, _c, _d, _e, _f;
        if (this.isMainSelector) {
            if (this.loadingDetailStatus.type === 'delivery') {
                return this.loadingDetailStatus.message;
            }
            else {
                return ((_b = (_a = this.projectSelected) === null || _a === void 0 ? void 0 : _a.project_type) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + ' - ' + ((_c = this.projectSelected) === null || _c === void 0 ? void 0 : _c.area_name);
            }
        }
        else {
            if (this.loadingDetailStatus.type === 'delivery2') {
                return this.loadingDetailStatus.message;
            }
            else {
                return ((_e = (_d = this.projectSelected) === null || _d === void 0 ? void 0 : _d.project_type) === null || _e === void 0 ? void 0 : _e.toUpperCase()) + ' - ' + ((_f = this.projectSelected) === null || _f === void 0 ? void 0 : _f.area_name);
            }
        }
    }
    updateProjectActive() {
        this.projectActiveInSelect = this.projectSelected;
    }
    updateCollapser() {
        (this.isNeedMaps) ? this.collapseLevel = 2 : this.collapseLevel = 2;
    }
    updateProjectSelected(model) {
        this.$emit('updateProjectSelected', model);
    }
    updateFarmSelected(f) {
        this.$emit('updateFarmSelected', f);
    }
    loadPreviousMetric() {
        this.$emit('loadPreviousMetric');
    }
    loadNextMetric() {
        this.$emit('loadNextMetric');
    }
    changeScope(scope) {
        this.$emit('changeScope', scope);
    }
    downloadMainDeliverable() {
        this.$emit('downloadMainDeliverable');
    }
    downloadQR() {
        this.$emit('downloadQR');
    }
    mounted() {
        if (this.isDoblePanelDeployed) {
            this.collapseLevel = 2;
        }
        this.updateCollapser();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: (Array), default: [] })
], ProjectControl.prototype, "projects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "projectSelected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "disabledProject", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "currentMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "vsMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "phchMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "vsPhChMetric", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectControl.prototype, "isMainSelector", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectControl.prototype, "isHoverSensitive", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectControl.prototype, "isDoblePanelDeployed", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "loadingDetailStatus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'bio' })
], ProjectControl.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProjectControl.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "currentProjectDelivery", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ProjectControl.prototype, "currentSubclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: true })
], ProjectControl.prototype, "isNeedMaps", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectControl.prototype, "isBiome", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ProjectControl.prototype, "isIT", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectControl.prototype, "currentFarm", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: [] })
], ProjectControl.prototype, "farms", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('projectSelected')
], ProjectControl.prototype, "updateProjectActive", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('isNeedMaps')
], ProjectControl.prototype, "updateCollapser", null);
ProjectControl = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Button: bmk_ui_framework_1.Button,
            Select: bmk_ui_framework_1.Select,
            Separator: bmk_ui_framework_1.Separator,
            ProjectSelector: ProjectSelector_vue_1.default,
            ProjectItem: ProjectItem_vue_1.default,
            MetricItem: MetricItem_vue_1.default,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ArrowLeft: lucide_vue_next_1.ArrowLeft,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            ArrowUp: lucide_vue_next_1.ArrowUp,
            Loading: bmk_ui_framework_1.Loading,
            CustomerSwitcher: CustomerSwitcher_vue_1.default,
        },
    })
], ProjectControl);
exports.default = ProjectControl;
